// extracted by mini-css-extract-plugin
module.exports = {"root":"ConsentHeader_root__11PUf","name":"ConsentHeader_name__2qU_c","birthday":"ConsentHeader_birthday__3AWJm","skeleton":"ConsentHeader_skeleton__2IuvP"};